module.exports = __webpack_public_path__ + "img/43.e306e776.png";